import React from "react";

class About extends React.Component {
  render() {
    return (
      <div className="modern-about-section" id="about">
        {/* Profile Section with Diagonal Layout */}
        <div className="profile-section">
          <div className="profile-content">
            <div className="profile-image-area">
              <div className="floating-profile">
                <img id="profile-pic" alt="" />
              </div>
            </div>
            
            <div className="profile-info-area">
              <div className="profile-text">
                <h1 className="profile-name">Dhruvin Modi</h1>
                <h2 className="profile-title">Software Engineer</h2>
                
                <p className="profile-description">
                  Software Engineer with 5+ years of architecting scalable mission-critical single-page applications using TypeScript, React, and GraphQL. Proven leadership in defining code standards, ensuring correctness in high-stakes environments, and delivering complex products that champion customer needs. Expertise building extensible design systems, optimizing frontend architecture, and leading cross-functional teams to deliver production-grade solutions with meticulous quality standards.
                </p>
                
                <div className="profile-details">
                  <div className="detail-item">
                    <span className="detail-label">Location</span>
                    <span className="detail-value">Ahmedabad, India</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Experience</span>
                    <span className="detail-value">5+ Years</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Phone</span>
                    <span className="detail-value">+91 846 905 7446</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Email</span>
                    <span className="detail-value">
                      <a href="mailto:dhruvin.developer@gmail.com">dhruvin.developer@gmail.com</a>
                    </span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Website</span>
                    <span className="detail-value">
                      <a href="https://dhruvinmodi.com" target="_blank" rel="noopener noreferrer">dhruvinmodi.com</a>
                    </span>
                  </div>
                </div>
                
                <div className="profile-action">
                  <a href="/resume/DhruvinModiResume.pdf"
                     className="download-cv-btn"
                     download="DhruvinModiResume.pdf">
                    Download Resume
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Company Logos with Rotating Effect */}
        <div className="rotating-logos-section">
          <div className="rotating-logos-container">
            <div className="rotating-logos-track">
              <div className="company-logo-item">
                <img className="company-logo edukite-logo" alt="edukite-logo" />
              </div>
              <div className="company-logo-item">
                <img className="company-logo freshflows-logo" alt="freshflows-logo" />
              </div>
              <div className="company-logo-item">
                <img className="company-logo auzmor-hire-logo" alt="auzmor-hire-logo" />
              </div>
              <div className="company-logo-item">
                <img className="company-logo atc-logo" alt="atc-logo" />
              </div>
              {/* Duplicate for seamless loop */}
              <div className="company-logo-item">
                <img className="company-logo edukite-logo" alt="edukite-logo" />
              </div>
              <div className="company-logo-item">
                <img className="company-logo freshflows-logo" alt="freshflows-logo" />
              </div>
              <div className="company-logo-item">
                <img className="company-logo auzmor-hire-logo" alt="auzmor-hire-logo" />
              </div>
              <div className="company-logo-item">
                <img className="company-logo atc-logo" alt="atc-logo" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;
